"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageWriter = void 0;
const issue_1 = require("./types/issue");
const utils_1 = require("./utils");
class StorageWriter {
    constructor(deviceKeysTable, issuesTable, logFactory, logsTable, MAX_LOG_TEXT_SIZE_BYTES = 32000, MAX_LOG_METHOD_SIZE_BYTES = 256, MAX_LOG_FILENAME_SIZE_BYTES = 256, MAX_LOG_URL_SIZE_BYTES = 2000, MAX_CRASH_TITLE_SIZE_BYTES = 32000, MAX_CRASH_TEXT_SIZE_BYTES = 5 * 1024 * 1024, MAX_ISSUES_TITLE_SIZE_BYTES = 32000, MAX_ISSUES_TEXT_SIZE_BYTES = 32000) {
        this.deviceKeysTable = deviceKeysTable;
        this.issuesTable = issuesTable;
        this.logFactory = logFactory;
        this.logsTable = logsTable;
        this.MAX_LOG_TEXT_SIZE_BYTES = MAX_LOG_TEXT_SIZE_BYTES;
        this.MAX_LOG_METHOD_SIZE_BYTES = MAX_LOG_METHOD_SIZE_BYTES;
        this.MAX_LOG_FILENAME_SIZE_BYTES = MAX_LOG_FILENAME_SIZE_BYTES;
        this.MAX_LOG_URL_SIZE_BYTES = MAX_LOG_URL_SIZE_BYTES;
        this.MAX_CRASH_TITLE_SIZE_BYTES = MAX_CRASH_TITLE_SIZE_BYTES;
        this.MAX_CRASH_TEXT_SIZE_BYTES = MAX_CRASH_TEXT_SIZE_BYTES;
        this.MAX_ISSUES_TITLE_SIZE_BYTES = MAX_ISSUES_TITLE_SIZE_BYTES;
        this.MAX_ISSUES_TEXT_SIZE_BYTES = MAX_ISSUES_TEXT_SIZE_BYTES;
        this.isClearingSpace = false;
        this.logsQueue = [];
    }
    handleMessage(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (msg.type) {
                case 'device-key':
                    return this.addDeviceKey(msg.data.key, msg.data.value, msg.data.callInfo, msg.data.time);
                case 'init': {
                    this.options = msg.data.options;
                    this.sessionUUID = msg.data.sessionUUID;
                    break;
                }
                case 'issue':
                    return this.addIssue(msg.data.type, msg.data.title, msg.data.text, msg.data.uuid, msg.data.callInfo, msg.data.time);
                case 'log-entry':
                    return this.addLogEntry(msg.data.log, msg.data.callInfo, msg.data.time);
            }
        });
    }
    addDeviceKey(key, value, callInfo, time) {
        this.deviceKeysTable.add({
            sessionUUID: this.sessionUUID,
            data: { key, value },
        });
        this.addLog(this.logFactory.createFromDeviceKey(key, value, callInfo, time));
    }
    addLog(log) {
        return __awaiter(this, void 0, void 0, function* () {
            const [t, m, f, u] = yield Promise.all([
                (0, utils_1.truncate)(log.t, this.MAX_LOG_TEXT_SIZE_BYTES),
                (0, utils_1.truncate)(log.m, this.MAX_LOG_METHOD_SIZE_BYTES),
                (0, utils_1.truncate)(log.f, this.MAX_LOG_FILENAME_SIZE_BYTES),
                (0, utils_1.truncate)(log.u, this.MAX_LOG_URL_SIZE_BYTES),
            ]);
            const entry = {
                sessionUUID: this.sessionUUID,
                data: Object.assign(Object.assign({}, log), { t,
                    m,
                    f,
                    u }),
            };
            if (this.isClearingSpace) {
                this.logsQueue.push(entry);
            }
            else {
                try {
                    yield this.logsTable.add(entry);
                }
                catch (err) {
                    if (this.isQuotaExceededError(err)) {
                        this.logsQueue.push(entry);
                        this.isClearingSpace = true;
                        yield this.logsTable.deleteOldLogs(this.sessionUUID);
                        yield this.processLogsQueue();
                        this.isClearingSpace = false;
                    }
                }
            }
        });
    }
    addLogEntry(log, callInfo, time) {
        this.addLog(this.logFactory.createFromEntry(log, callInfo, time));
    }
    addIssue(type, title, text, uuid, callInfo, time) {
        return __awaiter(this, void 0, void 0, function* () {
            const isCrash = type === issue_1.IssueType.Crash;
            [title, text] = yield Promise.all([
                (0, utils_1.truncate)(title, isCrash ? this.MAX_CRASH_TITLE_SIZE_BYTES : this.MAX_ISSUES_TITLE_SIZE_BYTES),
                (0, utils_1.truncate)(text, isCrash ? this.MAX_CRASH_TEXT_SIZE_BYTES : this.MAX_ISSUES_TEXT_SIZE_BYTES),
            ]);
            this.issuesTable.add({
                sessionUUID: this.sessionUUID,
                data: { title, text, type, uuid },
            });
            this.addLog(this.logFactory.createFromIssue(uuid, callInfo, time));
        });
    }
    isQuotaExceededError(err) {
        var _a;
        return ((err.name === 'QuotaExceededError') ||
            (((_a = err.inner) === null || _a === void 0 ? void 0 : _a.name) === 'QuotaExceededError'));
    }
    processLogsQueue() {
        return __awaiter(this, void 0, void 0, function* () {
            while (this.logsQueue.length > 0) {
                const entry = this.logsQueue[0];
                try {
                    yield this.logsTable.add(entry);
                    this.logsQueue.shift();
                }
                catch (err) {
                    if (this.isQuotaExceededError(err)) {
                        yield this.logsTable.deleteOldLogs(this.sessionUUID);
                    }
                }
            }
        });
    }
}
exports.StorageWriter = StorageWriter;
